export const JOB_CANDIDATE_STAT_ITEMS = [
  { id: "new", label: "New" },
  { id: "applied", label: "Applied" },
  { id: "matched", label: "Matched" },
  { id: "sourced", label: "Sourced" },
  { id: "contacted", label: "Contacted" },
  { id: "screened", label: "Screened" },
  { id: "presented", label: "Presented" },
  { id: "interviewing", label: "Interviewing" },
  { id: "assessments", label: "Assessments" },
  { id: "offer", label: "Offer" },
  { id: "hired", label: "Hired" },
  { id: "active", label: "Active" },
];

const JOB_CANDIDATE_STAT_LABELS = JOB_CANDIDATE_STAT_ITEMS.reduce((acc, item) => {
  acc[item.id] = item.label;
  return acc;
}, {});

const EMPTY_STAGE_VALUES = new Set(["", "none", "no stage", "null", "undefined"]);

const STAGE_ALIASES = new Map([
  ["new", "new"],
  ["applied", "applied"],
  ["matched", "matched"],
  ["sourced", "sourced"],
  ["contacted", "contacted"],
  ["screen", "screened"],
  ["screens", "screened"],
  ["screened", "screened"],
  ["presented", "presented"],
  ["interview", "interviewing"],
  ["interviewing", "interviewing"],
  ["assessment", "assessments"],
  ["assessments", "assessments"],
  ["offer", "offer"],
  ["hired", "hired"],
  ["active", "active"],
]);

export const normalizeJobCandidateStatusKey = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

export const normalizeJobCandidateStageKey = (value) => {
  const raw = String(value || "")
    .trim()
    .toLowerCase();

  if (EMPTY_STAGE_VALUES.has(raw)) return "";

  return STAGE_ALIASES.get(raw) || raw;
};

export const resolveJobCandidateExplicitStageKey = (row = {}) =>
  normalizeJobCandidateStageKey(row?.candidate_stage || row?.stage || "");

export const resolveJobCandidateDisplayStageKey = (row = {}) => {
  const explicitStage = resolveJobCandidateExplicitStageKey(row);
  if (explicitStage) return explicitStage;

  const status = normalizeJobCandidateStatusKey(row?.candidate_status || row?.status || "");
  if (status === "new" || status === "active" || status === "hired") {
    return status;
  }

  return "";
};

export const getJobCandidateStatLabel = (statId) =>
  JOB_CANDIDATE_STAT_LABELS[String(statId || "").trim().toLowerCase()] || "";

export const resolveJobCandidateDisplayStageLabel = (row = {}) => {
  const stageKey = resolveJobCandidateDisplayStageKey(row);
  return JOB_CANDIDATE_STAT_LABELS[stageKey] || "No stage";
};

export const isJobCandidateStatMatch = (row = {}, statId = "all") => {
  const normalizedStatId = String(statId || "")
    .trim()
    .toLowerCase();

  if (!normalizedStatId || normalizedStatId === "all") return true;

  const explicitStage = resolveJobCandidateExplicitStageKey(row);
  const status = normalizeJobCandidateStatusKey(row?.candidate_status || row?.status || "");

  switch (normalizedStatId) {
    case "new":
      return status === "new" && !explicitStage;
    case "applied":
      return explicitStage === "applied";
    case "matched":
      return explicitStage === "matched";
    case "sourced":
      return explicitStage === "sourced";
    case "contacted":
      return explicitStage === "contacted";
    case "screened":
      return explicitStage === "screened";
    case "presented":
      return explicitStage === "presented";
    case "interviewing":
      return explicitStage === "interviewing";
    case "assessments":
      return explicitStage === "assessments";
    case "offer":
      return explicitStage === "offer";
    case "hired":
      return explicitStage === "hired" || status === "hired";
    case "active":
      return status === "active";
    default:
      return false;
  }
};
